import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from '@unite-us/app-components';

export function InteractionCardField({
  children,
  icon,
  iconAriaLabel,
  dataTestId,
}) {
  return (
    <div className="flex min-w-0 items-center gap-2" data-testid={dataTestId}>
      {icon && (
        <Icon
          ariaLabel={iconAriaLabel}
          className="shrink-0"
          color="text-blue"
          icon={icon}
          size={16}
        />
      )}
      <span className="min-w-0 text-sm text-text-blue">{children}</span>
    </div>
  );
}

InteractionCardField.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
  iconAriaLabel: PropTypes.string,
  dataTestId: PropTypes.string,
};

InteractionCardField.defaultProps = {
  children: null,
  icon: undefined,
  iconAriaLabel: undefined,
  dataTestId: undefined,
};
